import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
import "../assets/css/slider.css"; // Custom styling
// import img1 from '../assets/images/Img1.png'
// import img2 from '../assets/images/Img2.png'
// import img3 from '../assets/images/Img3.png'
// const imageSlides = [
//     img1,
//     img2,
//     img3
// ];
import backgroundVideo from '../assets/videos/Tirupati_BG.mp4';
import { SERVER_URL } from '../constant/constant.js';

const Highlights = () => {
    return (
        <div className="slider-container">
            <video
                className="home_video"
                // src={SERVER_URL + "/video/highlights"}
                src={backgroundVideo}
                type="video/mp4"
                poster={""}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
            />
            {/* <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={5}
                slidesPerView={1}
                navigation={{
                    nextEl: ".custom-next",
                    prevEl: ".custom-prev",
                }}
                pagination={{ clickable: true }}
                autoplay={{ delay: 5000 }}
                loop={true}
            >
                {imageSlides.map((img, index) => (
                    <SwiperSlide key={index}>
                        <img src={img} alt={`Slide ${index + 1}`} className="slide-image" />
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="custom-navigation">
                <button className="custom-prev">❮</button>
                <button className="custom-next">❯</button>
            </div> */}
        </div>
    )
}

export default Highlights;